import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, inject } from '@angular/core';

import { LoggerService } from '@asset-solutions/shared/logging';
import { NotificationService } from '@asset-solutions/shared/utilities';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  private readonly loggerService = inject(LoggerService);
  private readonly notificationService = inject(NotificationService);

  public handleError(error: Error | HttpErrorResponse): void {
    let message;
    if (error instanceof HttpErrorResponse) {
      if (error.status !== 0 && (error.error as ErrorEvent)) {
        // generate http error message
        message = `${error.status} ${error.error.error}: ${error.error.message}`;
      } else {
        // Set message to the error's message if it is a 0 status error
        message = error.message;
      }
    } else {
      // Message for all other errors
      message = `${error.name} - ${error.message || 'Unknown error'}`;
    }
    this.notificationService.error(message);
    this.loggerService.error(message, error);
  }
}
